import React from "react";
import AdminBreadCrumb from "components/AdminBreadCrumb";
import FacturasDashboard from "../components/FacturasDashboard";

const BillingDashboard = () => {
  const breadCrumbs = [
    { text: "BILLING", url: "/admin/billing-dashboard" },
    { text: "DASHBOARD", url: "/admin/billing-dashboard" }
  ];

  return (
    <div className="billing-dashboard-page admin">
      <div className="common-header">
        <AdminBreadCrumb breadCrumbs={breadCrumbs} />
      </div>

      <div className="content-wrapper">
        <FacturasDashboard />
      </div>
    </div>
  );
};

export default BillingDashboard;
